import { computed } from 'vue'
import { useDialersStore } from '@voicenter-team/events-sdk-vue-3'
import { Dialer } from '@/types/dialers'

const dialersStore = useDialersStore()

export default function useDialers () {
    const allDialers = computed<Dialer[]>(() => {
        return (dialersStore.dialerListAll.value as unknown as Dialer[]) || []
    })
    const dialersWithTypeIVR = computed<Dialer[]>(() => {
        return (dialersStore.dialerListIVR.value as unknown as Dialer[]) || []
    })

    const dialersWithTypeAUTOMATIC = computed<Dialer>(() => {
        return (dialersStore.dialerListAutomatic.value as unknown as Dialer) || []
    })

    return {
        allDialers,
        dialersWithTypeAUTOMATIC,
        dialersWithTypeIVR
    }
}
